/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as l } from "../../../chunks/jsx-runtime.BwWtxLpl.js";
import { d as a } from "../../../chunks/index.esm.eyITaPoj.js";
import { Alert as f } from "@nubeteck/components";
import x from "../../form-item/form-item.js";
const y = ({
  name: t,
  help: m,
  label: s,
  rules: i,
  tooltip: d,
  alertType: u,
  defaultValue: n,
  formatMessage: e,
  renderFormItem: p = !0,
  ...r
}) => {
  const { field: o } = a({
    name: t,
    rules: i,
    defaultValue: n,
    disabled: r.disabled
  });
  return /* @__PURE__ */ l.jsx(
    x,
    {
      name: t,
      help: m,
      label: s,
      tooltip: d,
      noStyle: !p,
      children: /* @__PURE__ */ l.jsx(
        f,
        {
          type: u,
          ...r,
          message: e ? e(o.value) : o.value ?? "..."
        }
      )
    }
  );
};
export {
  y as default
};
